// Telefonda alt hızlı menü: yıldızlanan ilk 4 menü + tüm menüyü açan "Menü"
import { NavLink } from 'react-router-dom';
import { Menu, Star } from 'lucide-react';
import { arrange } from './SidebarNav';

const cls = (active) => `flex min-w-0 flex-1 flex-col items-center justify-center gap-0.5 px-1 py-1.5 text-[10px] leading-tight transition-colors ${active ? 'text-orange-600 font-semibold' : 'text-slate-500'}`;

export const MobileQuickBar = ({ items, prefs, onMenu, onNavigate }) => {
  const [favs] = arrange(items, prefs);
  const shown = favs.length ? favs.slice(0, 4) : items.filter(i => i.path === '/').slice(0, 1);
  return (
    <nav className="fixed inset-x-0 bottom-0 z-50 border-t border-slate-200 bg-white/95 pb-[env(safe-area-inset-bottom)] backdrop-blur lg:hidden" data-testid="mobile-quick-bar">
      <div className="flex h-16 items-stretch">
        {shown.map(item => (
          <NavLink key={item.path} to={item.path} end={item.path === '/'} onClick={onNavigate} className={({ isActive }) => cls(isActive)} data-testid={`quick-${item.path.replace('/', '') || 'dashboard'}`}>
            <item.icon className="h-5 w-5 shrink-0" />
            <span className="w-full truncate text-center">{item.label}</span>
          </NavLink>
        ))}
        {!favs.length && (
          <button type="button" onClick={onMenu} className="flex flex-[2] items-center justify-center gap-1.5 px-2 text-[11px] text-slate-400" data-testid="quick-hint">
            <Star className="h-3.5 w-3.5 shrink-0 text-amber-400" />Yıldızla, buraya ekle
          </button>
        )}
        <button type="button" onClick={onMenu} className={cls(false)} data-testid="quick-menu">
          <Menu className="h-5 w-5 shrink-0" />
          <span>Menü</span>
        </button>
      </div>
    </nav>
  );
};
